"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _colors = require("MeetingsBase/constants/colors");

var defaults = {
  primaryColor: _colors.DEFAULT_COLOR,
  logoUrl: null,
  logoAltText: null,
  companyName: null
};

var Branding =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Branding, _Record);

  function Branding() {
    (0, _classCallCheck2.default)(this, Branding);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Branding).apply(this, arguments));
  }

  (0, _createClass2.default)(Branding, null, [{
    key: "from",
    value: function from(json) {
      if (json) {
        var logoUrl = json.hasOwnProperty('logoUrl') ? json.logoUrl : json.companyLogo;
        var primaryColor = json.hasOwnProperty('primaryColor') ? json.primaryColor : json.accentColor;
        return new Branding({
          primaryColor: primaryColor || _colors.DEFAULT_COLOR,
          logoUrl: logoUrl,
          logoAltText: json.logoAltText,
          companyName: json.companyName
        });
      }

      return new Branding();
    }
  }]);
  return Branding;
}((0, _immutable.Record)(defaults));

exports.default = Branding;
module.exports = exports.default;